
<div class="showcase-collection-view">
  <align flex collapse-end direction="flex-start">
    <shared-filters
      show-recent-searches
      :filters.sync="filters"
      :query.sync="query"
      :properties="defaultFilters"
      @clear="clearFilters"
    />

    <direction-sort-options
      :sort.sync="sort"
      :direction.sync="direction"
      :options="sortOptions"
    />
  </align>

  <filter-results
    :is-filtering="isFiltering"
    :filters="filters"
    :results="numResults"
    @clear="clearFilters"
  />

  <div class="results">
    <empty-state
      v-if="showEmptyState"
      icon="search_off"
      title="There are no results for your query"
      description="Try searching for something else"
    />

    <template v-if="loaded">
      <div class="grid">
        <showcase-card
          v-for="card in cards"
          :key="card.id"
          as="router-link"
          :card="card"
          :to="{ query: { ...$route.query, showcaseCardId: card.id } }"
        />
      </div>

      <infinite-scroll
        :loading="loading"
        :has-more-data="hasMoreData"
        @load="loadMore"
      />
    </template>
  </div>

  <scroll-top />
</div>
